import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import App from './App.vue'
import request from './utils/request'
import echarts from './plugins/echarts'

const app = createApp(App)

app.use(ElementPlus)
app.config.globalProperties.$axios = request
app.config.globalProperties.$echarts = echarts
app.provide('axios', request)
app.provide('echarts', echarts)

app.mount('#app')
